import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PerModal } from '../../../../../components/custom_components/Modal'
import PerFlexRow from '../../../../../components/custom_components/FlexRow'
import PerText from '../../../../../components/custom_components/Text'
import { GecoProjectsInfo } from '../../../../../types'
import { GecoProjectRow } from './GecoProjectRow'
import { Col } from 'antd'

interface GecoShowBookingsModalProps {
  open: boolean
  onCancel: () => void
  projects: GecoProjectsInfo[]
}

export const GecoBookingsModal: FC<GecoShowBookingsModalProps> = ({ open, onCancel, projects }) => {
  const { t } = useTranslation()

  return (
    <PerModal
      title={{ heading: t('appraisalMeeting.stepOverview.pageDescriptionProjects.titleGecoInfo') }}
      size="large"
      visible={open}
      onCancel={onCancel}
    >
      {projects.map((project) => {
        return (
          <PerFlexRow key={project.id} align="middle">
            <Col span={19}>
              <GecoProjectRow label={project.projectName} percent={project.bookedTimeInPercent} color={project.id} />
            </Col>
            <Col span={5}>
              <PerText align="right" fontSize="m" mb="s" color="secondary">{`${project.hours} ${t(
                'appraisalMeeting.stepOverview.pageDescriptionProjects.hoursUnit',
              )}`}</PerText>
            </Col>
          </PerFlexRow>
        )
      })}
    </PerModal>
  )
}
